for (const iframe of document.querySelectorAll<HTMLIFrameElement>("iframe.wp-block-plaudit-embedded-catalog")) {
	const iframeURL = new URL(iframe.src);

	// This horror show uses replaceState() because embedded iframes apparently get navigation priority over the root frame.
	window.addEventListener('message', e => {
		if (e.origin !== iframeURL.origin || typeof e.data !== 'object') {
			return;
		}
		if (typeof e.data["height"] === 'string') {
			iframe.height = e.data["height"];
		}
		if (typeof e.data["url"] === 'string') {
			const windowURL = new URL(window.location.href);
			for (const key of windowURL.searchParams.keys()) {
				windowURL.searchParams.delete(key);
			}

			const iframeURL = new URL(e.data["url"]);
			iframeURL.searchParams.delete("embedded");
			windowURL.search = iframeURL.search;
			if (windowURL.href !== window.location.href) {
				window.history.replaceState({}, "", windowURL.href);
			}
		}
	});

	const lastBreadcrumb = document.body.querySelector<HTMLElement>(".aioseo-breadcrumbs .aioseo-breadcrumb:last-child");
	if (lastBreadcrumb) {
		const text = lastBreadcrumb.textContent ?? "";
		const anchor = document.createElement("a");
		anchor.title = text;
		anchor.textContent = text;
		anchor.classList.add("forceClickable")
		const url = new URL(window.location.href);
		url.search = "";
		anchor.href = url.toString();
		lastBreadcrumb.replaceChildren(anchor);
	}
}
